import React from "react";

const PerformanceChart = ({ data, theme }) => {
  // const maxScore = Math.max(...data?.map((d) => d.score));

  return (
    <div className="space-y-4">
      {data?.map((item, index) => (
        <div key={index} className="flex items-center space-x-4">
          <div className={`w-12 text-center ${theme.text} font-medium`}>
            {item?.question}
          </div>
          <div className="flex-1 bg-gray-200 rounded-full h-6 relative">
            <div
              className={`h-6 rounded-full transition-all duration-1000 ${
                item?.score >= 80
                  ? "bg-green-500"
                  : item.score >= 60
                  ? "bg-yellow-500"
                  : "bg-red-500"
              }`}
              style={{ width: `${(item?.score / 100) * 100}%` }}
            />
            <span className="absolute inset-0 flex items-center justify-center text-sm font-medium text-white">
              {item.score}%
            </span>
          </div>
          <span
            className={`w-16 text-xs px-2 py-1 rounded text-center ${
              item?.difficulty === "Easy"
                ? "bg-green-100 text-green-800"
                : item?.difficulty === "Medium"
                ? "bg-yellow-100 text-yellow-800"
                : "bg-red-100 text-red-800"
            }`}
          >
            {item?.difficulty}
          </span>
        </div>
      ))}
    </div>
  );
};

export default PerformanceChart;